import { apiHandler } from '@/services/apiHandler';
import { internalAxios } from '@/services/axiosInstances';
import type { InitKioskCodeRes, KioskConfigDto, KioskConfigParams } from '@/services/dto';
import { KIOSK_ENDPOINTS } from '@/services/endpoints';
import type { ApiResponse } from '@/types/api';

/**
 * Get kiosk configuration by machine ID
 */
export const getKioskConfig = async (params: KioskConfigParams): Promise<ApiResponse<KioskConfigDto>> => {
    return apiHandler(async () => await internalAxios.get(`${KIOSK_ENDPOINTS.CONFIG}?machineCode=${params.machineCode}&serverType=s3`));
};

export const initKioskCode = async (kioskCode: string): Promise<ApiResponse<InitKioskCodeRes>> => {
    return apiHandler(async () => await internalAxios.post(KIOSK_ENDPOINTS.INIT_KIOSK_CODE, { kioskCode }));
};
